<template>
  <div class="maintenance">
    <div class="gradient-panel">
      <div class="content-area">
          <div class="grid-x grid-padding-x">
          <div class="cell small-12 medium-6 medium-offset-3 center">
            <img class="backsoon-image" :src="getImage('backsoon.png')">
          </div>
          <div class="cell small-12 center">
            <h2>{{ strings.header }}</h2>
          </div>
          <div class="cell small-12 center">
            {{ strings.details }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Strings
import strings from '@/i18n/en/strings';

export default {
  name: 'maintenance-page',
  created() {
    window.scrollTo(0, 0);
    // Check whether maintenance mode is still enabled
    // If maintenance mode has been disabled, redirect the user to the Find Your Bill page
    this.$store.dispatch('FETCH_MAINTENANCE_MODE_STATUS')
      .then((isMaintenanceMode) => {
        if (!isMaintenanceMode) {
          this.redirectToPage('find-your-bill');
        }
      })
      .catch(() => {
        setTimeout(function () {
          this.goToPage('error');
        }, 0);
      });
  },
  data() {
    return {
      strings: strings.maintenance
    }
  }
};
</script>

<style lang="scss" scoped>
.maintenance {
  .gradient-panel {
    // Gradient bar needs to be shown on top and bottom of page
    border-image-slice: 1 1 1;

    .backsoon-image {
      padding-bottom: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Maintenance.vue